import { createSelector } from 'reselect';

const getVehiclesAccesor = state => state.tickets.vehicles;

export const vehiclesSelector = createSelector(getVehiclesAccesor, vehicles => vehicles);
